var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.value))]),(_vm.display)?_c('span',{staticStyle:{"font-size":".8em","opacity":".6"}},[_vm._v(" ("+_vm._s(_vm.display)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }